import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Puis-je contester la suspension de mon permis de conduire?"
            description="Votre permis de conduire a été suspendu par un policier et vous souhaitez contester la décision? JuriGo vous explique toutes les étapes à suivre afin de retrouver votre permis."
            fr={undefined}
            lawType="criminal"
            specialtyText="spécialisé en alcool au volant">
            <p>
                Que vous en soyez à votre{' '}
                <Link to="https://avocatsalcoolauvolant.ca/premiere-infraction-alcool-volant/">
                    première infraction d’alcool au volant
                </Link>{' '}
                ou non, il est important de savoir que votre permis de conduire
                sera suspendu, et ce, dès votre arrestation.{' '}
            </p>
            <p>
                <strong>
                    En revanche, il est toujours possible de contester la
                    décision de suspension.{' '}
                </strong>
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Comment réviser une décision de suspension de permis de conduire?"
                    alt=""
                />
            </p>
            <p>
                Pour ce faire, il faudra rapidement s’adresser au Service de
                révision de la Société de l’assurance automobile du Québec.
                C’est à celle-ci que revient la décision de rétablir votre
                permis ou non.
            </p>
            <p>
                <strong>
                    JuriGo vous aide à comprendre les étapes à suivre afin de
                    contester la suspension de votre permis de conduire.
                </strong>
            </p>
            <h2>Comment contester une suspension de la SAAQ?</h2>
            <p>
                La Société de l’assurance automobile du Québec a le pouvoir de
                suspendre un permis de conduire pour une durée de 30, 60 ou 90
                jours. Dans ce cas, il vous sera possible{' '}
                <strong>de demander une révision. </strong>
            </p>
            <p>
                Pour présenter une demande de révision, il faudra être en mesure
                de démontrer l’un des motifs suivants:
            </p>
            <ul>
                <li>
                    Vous n’aviez pas d’alcool dans votre organisme alors que
                    vous êtes soumis à la tolérance zéro,
                </li>
                <li>
                    Votre taux d’alcool n’atteint pas 80 mg par 100 ml de sang,
                </li>
                <li>Vous ne conduisiez pas le véhicule, ou </li>
                <li>
                    Vous n’aviez pas{' '}
                    <Link to="https://avocatsalcoolauvolant.ca/accusation-garde-controle-alcool/">
                        le contrôle (ou la garde) du véhicule
                    </Link>
                    .
                </li>
            </ul>
            <p>
                Il vous sera également possible de présenter une demande de
                révision si vous aviez une excuse raisonnable pour{' '}
                <strong>refuser d’obéir à un ordre d’un agent</strong>. Ce sera
                notamment le cas lorsqu’il vous demande de fournir un
                échantillon d’haleine ou de vous soumettre aux épreuves de
                coordination de mouvements.
            </p>
            <p>
                <strong>
                    Voici les étapes à suivre pour contester une suspension de
                    permis de la SAAQ:
                </strong>
            </p>
            <h3>1) Préparer la demande de révision</h3>
            <p>
                La première étape sera de remplir (et de signer) le formulaire{' '}
                <em>
                    Demande de révision de la suspension de permis ou du droit
                    d’en obtenir un
                </em>
                . Vous devrez également joindre à votre demande la version
                originale du procès-verbal de la suspension du permis de
                conduire.
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="À qui dois-je adresser ma contestation de suspension de permis?"
                    alt=""
                />
            </p>
            <p>
                Si le policier vous a intercepté et a allégué que vous aviez un
                taux d’alcool supérieur à 80 mg par 100 ml de sang, il aura
                coché l’article 202.4 (par. 1). Dans ce cas, il faudra fournir
                une copie du <strong>certificat du technicien qualifié</strong>{' '}
                qui porte sur l’analyse d’un échantillon d’haleine ou de sang.{' '}
            </p>
            <p>
                Toutefois, s’il s’agit d’un cas de conduite avec{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-conduite-facultes-affaiblies/">
                    les capacités affaiblies
                </Link>{' '}
                par la drogue confirmé par un échec des épreuves, le policier va
                cocher l’article 202.4.1 (par. 1). Il faudra, pour présenter la
                demande de révision, fournir une copie du document de l’agent
                évaluateur.
            </p>
            <p>
                Il vous sera possible de joindre à votre demande tout document
                que vous considérez comme pertinent afin de soutenir votre
                demande de révision. Cela peut notamment être un rapport médical
                ou une preuve d’expert.{' '}
            </p>
            <p>
                Outre ces documents, vous pouvez toujours joindre les documents
                que vous considérez comme{' '}
                <strong>pertinents à votre demande</strong>.{' '}
            </p>
            <h3>2) Transmettre la demande de révision</h3>
            <p>
                Une fois votre demande de révision complétée, il vous faudra
                l’envoyer à la SAAQ. Cela pourra être fait de deux manières
                différentes:
            </p>
            <ul>
                <li>En personne à l’un de nos points de services, ou </li>
                <li>
                    Par la poste (adressée au Service de la révision de la
                    Société de l’assurance automobile du Québec).
                </li>
            </ul>
            <p>
                <strong>Attention!</strong> Si vous avez une suspension de 90
                jours, il vous sera possible de demander une rencontre avec un
                agent de la SAAQ. Cette rencontre aura lieu dans les 10 jours
                qui suivent le dépôt de votre demande.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Qu’est-ce qu’un permis de conduire restreint?"
                    alt=""
                />
            </p>
            <p>
                C’est lors de cette rencontre que vous pourrez présenter non
                seulement des témoins ordinaires, mais également des experts.{' '}
            </p>
            <h3>3) Attendre la réponse de la SAAQ</h3>
            <p>
                En temps normal, le délai d’attente pour une réponse à votre
                demande de révision est de <strong>10 jours</strong> à partir du
                dépôt de la demande de révision ou du dépôt des documents
                supplémentaires.
            </p>
            <p>
                Si la décision de révision est favorable, la suspension de votre
                permis sera levée et vous pourrez recommencer à conduire.
                Toutefois, si la décision est défavorable, la suspension sera
                maintenue.
            </p>
            <p>
                Dans ce cas, il vous sera possible de contester la demande de
                révision devant le Tribunal administratif du Québec. Cette
                démarche doit être faite dans un{' '}
                <strong>délai de 10 jours</strong> à partir de la date de la
                décision.
            </p>
            <p>
                <strong>
                    Contestez la décision de la SAAQ dès aujourd’hui à l’aide
                    d’un avocat partenaire de JuriGo!
                </strong>
            </p>
            <h2>Comment récupérer mon permis de conduire?</h2>
            <p>
                Il est important de faire une distinction entre les périodes
                d’interdiction de conduire et la suspension de votre permis.
                Pendant la période d’interdiction, il ne sera jamais possible de
                récupérer votre permis.
            </p>
            <p>
                Une fois cette période finie, il est possible que votre permis
                soit suspendu. Il sera néanmoins possible d’obtenir{' '}
                <strong>un permis restreint</strong>. Pour ce faire, il faudra:
            </p>
            <ul>
                <li>Avoir un antidémarreur, et </li>
                <li>
                    Se présenter à l’un des points de services de la SAAQ avec
                    un contrat de location pour la délivrance du permis.
                </li>
            </ul>
            <p>
                Pour obtenir un tel permis, il faudra payer certains frais pour
                le permis ainsi que pour l’installation de l’appareil dans votre
                véhicule et sa location mensuelle. Grâce à un permis restreint,
                vous avez l’obligation de conduire un véhicule équipé d’un
                antidémarreur.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Est-ce possible de récupérer un permis de conduire?"
                    alt=""
                />
            </p>
            <p>
                Si vous ne respectez pas cette obligation, vous êtes considéré
                comme un <strong>conducteur sans permis</strong>. Ainsi, l’agent
                qui vous intercepte au volant d’un véhicule va immédiatement
                saisir le véhicule, vous imposer une contravention d’environ 2
                500 $ ainsi qu’une suspension de 3 mois de votre permis de
                conduire, voire la révocation de ce dernier.{' '}
            </p>
            <p>
                Généralement l’obligation d’avoir un antidémarreur
                éthylométrique aura une durée d’une année ou deux. Toutefois,
                selon votre situation, il est possible que l’obligation de
                l’antidémarreur vous suive pour toujours.{' '}
            </p>
            <h2>
                Contester la suspension de votre permis grâce à un avocat de
                JuriGo!
            </h2>
            <p>
                Dès que vous êtes intercepté par un policier qui vous accuse
                d’avoir conduit avec les facultés affaiblies, il est nécessaire
                de faire appel à un avocat spécialisé en droit criminel. Ce
                dernier pourra vous représenter à toutes les étapes.
            </p>
            <p>
                Si vous souhaitez contester une décision de suspension de votre
                permis de conduire, il sera possible de s’adresser à la SAAQ par
                l’entremise de votre avocat qui s’occupera de toutes les étapes
                du processus.
            </p>
            <p>
                <strong>
                    N’attendez plus et remplissez dès maintenant le formulaire
                    en ligne pour trouver l’avocat qu’il vous faut!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "contestation-suspension-permis/revision-decision-suspension.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "contestation-suspension-permis/saaq-revision-suspension.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "contestation-suspension-permis/permis-conduire-restreint.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "contestation-suspension-permis/recuperer-permis-conduire.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
